import ActivityShowContextProvider from "PFApp/activities/show/context/activity_show_context_provider";
import { ActivityShowStoreProvider } from "PFApp/activities/show/store";
import { ReassignActionContextProvider } from "PFApp/booking/parts/overview/booking_module_calendar/context/reassign_action_context_provider";
import { useParams } from "react-router";

import { ActivityPage } from "./activity_page";

const ActivityShowController = () => {
  const { id } = useParams();

  return (
    <ActivityShowContextProvider id={id}>
      <ActivityShowStoreProvider>
        <ReassignActionContextProvider>
          <ActivityPage />
        </ReassignActionContextProvider>
      </ActivityShowStoreProvider>
    </ActivityShowContextProvider>
  );
};

export default ActivityShowController;
